module.exports = __webpack_public_path__ + "img/main_story_slide5.1ad9daa6.jpg";